import myaxios from '../utils/myaxios'


export function isHaveAgent(data) {
    return myaxios({
        url: '/manager/agent/isHaveAgent',
        data,
        method: 'post'
    })
}

export function getAgentList(data) {
    return myaxios({
        url: '/manager/agent/getAgents',
        data,
        method: 'post'
    })
}

export function addProstorePrice(data) {
    return myaxios({
        url: '/manager/agent/preStored',
        data,
        method: 'post'
    })
}

export function stopAgent(data) {
    return myaxios({
        url: '/manager/agent/stopAgent',
        params: data
    })
}

export function importAgent(data) {
    return myaxios({
        url: '/manager/agent/import-agent',
        data,
        method:'post'
    })
}

export function addAgent(data) {
    return myaxios({
        url: '/manager/agent/saveAgent',
        data,
        method: 'post'
    })
}

export function getSearchAgent(data) {
    return myaxios({
        url: '/manager/agent/getSearchAgent',
        data,
        method: 'post'
    })
}



export function queryAgentLow() {
    return myaxios({
        url: '/manager/agent/queryAgentLow',
    })
}

export function queryAgent() {
    return myaxios({
        url: '/manager/agent/queryAgent',
    })
}

export function saveBalanceByGift(data) {
    return myaxios({
        url: '/manager/agent/saveBalanceByGift',
        data,
        method: 'post'
    })
}

export function addAgentPrestorePrice(data) {
    return myaxios({
        url: '/manager/agent/ag-sv-pre',
        data,
        method: 'post'
    })
}

export function checkWxProstorePrice(data) {
    return myaxios({
        url: '/manager/agent/qu-wx-ord/'+data,
    })
}